<template>
  <div class="settings-confirmation-msg">
    <transition name="fade">
      <span
        v-if="confirmation.status"
        :style="getColorMsg"
        class="confirmation-msg"
      >{{ confirmation.msg }}</span>
    </transition>
  </div>
</template>
<script>
export default {
  props: ['confirmation'],
  computed: {
    getColorMsg: function () {
      if (this.confirmation.status === 'error') return { color: 'red' }
      if (this.confirmation.status === 'duplicate') return { color: 'black' }
      else return { color: 'green' }
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style scoped>
  .settings-confirmation-msg {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    display: inline-block;
    margin-top: 20px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
